"use strict";


var Payrolls = Backbone.Collection.extend({
    
    comparator: function(a, b){
        if(a.get("userId") == b.get("userId")){
            return a.get("workDate") - b.get("workDate");
        }else {
            var u1 = Core.client.users.get(a.get("userId"));
            var u2 = Core.client.users.get(b.get("userId"));
            return u1.get("fullName").localeCompare(u2.get("fullName"));
        }
    },

    defaultFilterParams: {
        path: 'all',
        from: null,
        to: null,
        groupIds: null,
        attested: false,
    },

    url: function(options) {
        if (!options) options = {};
		if (this.customUrl)
			return this.customUrl;

        var url;
        var params = { };
        url = Core.contextRoot + '/payroll' + (this.filterParams.path ? '/'+this.filterParams.path : '');
        if(this.filterParams.id) url += "/" + this.filterParams.id;
        if(this.filterParams.from) params.from = this.filterParams.from;
        if(this.filterParams.to) params.to = this.filterParams.to;
        if(this.filterParams.groupIds) params.groupIds = this.filterParams.groupIds;
        if(this.filterParams.userIds) params.userIds = this.filterParams.userIds;
        if(this.filterParams.attested) params.attested = this.filterParams.attested;
        var paramsStr = $.param(params);
		if (paramsStr.length > 0)
			url += '?' + paramsStr;
        return url;
    },

    initialize: function(models, options) {
        this.filterParams = _(this.defaultFilterParams).clone();
        if(models && models.id) this.filterParams.id = models.id;
    },

    destroyByUuid: function() {
        return $.ajax({
            url: Core.contextRoot + '/payroll/' + this.filterParams.id,
            type: 'DELETE'
        });
    },

    savePayroll: function(){
        var data = {
            groupId : this.filterParams.groupIds,
            userIds : this.filterParams.userIds,
            payrollPeriod: this.filterParams.from,
            payrollPeriodEnd: this.filterParams.to,
            payrolls: JSON.stringify(this.models)
        };
        return $.ajax({
            url: Core.contextRoot + '/payroll',
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json'
        });
    }
});

